export const capitalizeString = (str: string): string => {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};

export const formatFullName = (
  lastName?: string,
  firstName?: string,
  middleName?: string,
  makeUppercase: boolean = false,
): string => {
  const formattedName = [lastName, firstName, middleName]
    .filter((name): name is string => name !== undefined)
    .join(" ");

  return makeUppercase
    ? formattedName.toUpperCase().trim()
    : formattedName.trim();
};

export const isValidURL = (url: string): boolean => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])?)\\.)+[a-z]{2,}|" + // domain name
      "localhost|" + // localhost
      "\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|" + // OR ipv4
      "\\[?[a-fA-F0-9]*:[a-fA-F0-9:]+\\])" + // OR ipv6
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // fragment locator
  return !!pattern.test(url);
};

export const truncateString = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) {
    return str;
  }
  return str.slice(0, maxLength) + "...";
};
